import React, { Component } from "react";
import "moment/locale/id.js";
import CurrencyFormat from "react-currency-format";
import { DatePickerInput } from "rc-datepicker";
import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import { trackPromise } from "react-promise-tracker";

import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBBtn,
} from "mdbreact";

const showSecond = false;
const str = showSecond ? "HH:mm:ss" : "HH:mm";

const moment = require("moment");

class Verifikasi_bukti_bayar_detail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      student_id: "",
      is_show: false,
      isLoading: false,
      note_verification: "",
      previewImage: "",
      unit_detail: null,
    };
  }

  getFiles(files) {
    this.setState({
      encrypt_64: files[0].base64,
      original_name: files[0].name,
    });
  }

  componentDidMount() {
    const studentDetail = JSON.parse(localStorage.getItem("STUDENT_DETAIL"));
    this.setState({
      student_id: localStorage.getItem("DATA_JALUR").split("-")[0],
      student_detail: studentDetail,
      is_show: true,
    });
    if (studentDetail && studentDetail.subdomain) {
      this.fetchUnitDetail(studentDetail.subdomain);
    }
  }

  fetchUnitDetail = (subdomain) => {
    fetch(global.variable.LINK_API + "unit/detail", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + global.cookies.get("access_token"),
      },
      body: JSON.stringify({ subdomain }),
    })
      .then((response) => response.json())
      .then((resData) => {
        if (resData.message === "Success") {
          this.setState({ unit_detail: resData.data });
        }
      });
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onChangeDate = (jsDate, dateString) => {
    this.setState({ tanggal_wawancara: dateString });
  };

  onChangeTime = (value) => {
    let val;
    if (value) {
      val = value.format(str) + ":00";
    } else {
      val = "00:00:00";
    }
    this.setState({ jam_wawancara: val });
  };

  handleSubmit = (event) => {
    this.setState({ isLoading: true });
    event.preventDefault();
    const form_data = new FormData();
    form_data.append("registration_id", this.state.student_id);
    form_data.append("action", "next");
    // form_data.append('data', JSON.stringify(data));

    trackPromise(
      fetch(global.variable.LINK_API + "flow/update", {
        method: "post",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + global.cookies.get("access_token"),
        },
        body: form_data,
      })
        .then(this.handleErrors)
        .then((response) => response.json())
        .then((resData) => {
          if (resData.message === "Success") {
            global
              .swal("Success", "Berhasil Verifikasi Bukti Bayar", "success")
              .then((value) => {
                this.props.history.push("/verifikasibuktipendaftaran");
              });
          } else {
            global.swal(resData.error);
          }
        })
        .catch((err) => {
          if (err) {
            if (err.code !== 403) {
              let message;
              if ('errors' in err) {
                if (Array.isArray(err.errors)) {
                  message = err.errors[0];
                } else {
                  message = err.errors;
                }
              } else {
                message = "Koneksi ke server gagal.";
              }
              global.swal("Error", message, "info");
            }
          } else {
            global.swal.stopLoading();
            global.swal.close();
          }
        })
    );
  };

  handleErrors = async (response) => {
    this.setState({
      isLoading: false
    })
    if (!response.ok) {
      const errors = await response.clone().json();
      const errorMessage = { code: response.status, ...errors }
      throw errorMessage;
    }
    return response;
  }

  download = (param) => (e) => {
    e.preventDefault();
    // console.log(param);
    window.open(
      // "/image/" + param,
      param,
      "_blank",
      "location=yes,height=600,width=600,scrollbars=yes,status=yes"
    );

    //var newTab = window.open(param, "_blank", 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    //newTab.document.body.innerHTML = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==" width="100px" height="100px">';
  };

  form1() {
    const { student_detail } = this.state;

    return (
      <React.Fragment>
        <div className="form-group col-md-6 mb-2">
          <label>Nomor Registrasi</label>
          <input
            className="form-control form-control-sm"
            type="Text"
            name="gender"
            maxLength="100"
            value={
              student_detail.year +
              "-" +
              student_detail.registration_type_id +
              "-" +
              student_detail.registration_number
            }
            disabled
          />
        </div>
      </React.Fragment>
    );
  }

  formbukti() {
    const { student_detail } = this.state;
    return student_detail.image_link_bukti_transfer ? (
      <div className="mt-2">
        <img
          src={student_detail.image_link_bukti_transfer}
          alt="Bukti Bayar"
          style={{
            width: 150,
            cursor: "pointer",
            border: "1px solid #ddd",
            borderRadius: 4,
          }}
          onClick={() =>
            this.setState({
              previewImage: student_detail.image_link_bukti_transfer,
            })
          }
        />
      </div>
    ) : (
      ""
    );
  }

  formunit() {
    const { unit_detail } = this.state;
    const currency = Intl.NumberFormat("en-ID");
    return (
      <React.Fragment>
        <div className="form-group col-md-6 mb-2">
          <label>Nama Bank</label>
          <input
            className="form-control form-control-sm"
            type="Text"
            value={unit_detail.bank_name || ""}
            disabled
          />
        </div>
        <div className="form-group col-md-6 mb-2">
          <label>Nomor Rekening</label>
          <input
            className="form-control form-control-sm"
            type="Text"
            value={unit_detail.account_number || ""}
            disabled
          />
        </div>
        <div className="form-group col-md-6 mb-2">
          <label>Atas Nama</label>
          <input
            className="form-control form-control-sm"
            type="Text"
            value={unit_detail.account_name || ""}
            disabled
          />
        </div>
        <div className="form-group col-md-6 mb-2">
          <label>Biaya Pendaftaran</label>
          <input
            className="form-control form-control-sm"
            type="Text"
            value={
              "Rp. " + currency.format(unit_detail.registration_fee || 0)
            }
            disabled
          />
        </div>
      </React.Fragment>
    );
  }

  handleTolak = (event) => {
    event.preventDefault();
    global
      .swal({
        text: "Alasan ditolak?",
        content: "input",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: ["Cancel", { text: "Submit", closeModal: false }],
      })
      .then((confirm) => {
        let errorMessage = { code: 403, message: "cancel" };
        if (!confirm) throw errorMessage;
        const data = [];
        let items;
        items = Object.create({});
        items.field = "note_reject";
        items.value = confirm;
        data.push(items);
        const form_data = new FormData();
        form_data.append("registration_id", this.state.student_id);
        form_data.append("action", "reject");
        form_data.append("data", JSON.stringify(data));
        trackPromise(
          fetch(global.variable.LINK_API + "flow/update", {
            method: "post",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + global.cookies.get("access_token"),
            },
            body: form_data,
          })
            // })
            .then(this.handleErrors)
            .then((response) => response.json())
            .then((resData) => {
              if (resData.message === "Success") {
                console.log(resData);
                global
                  .swal("Success", "Berhasil Tolak", "success")
                  .then((value) => {
                    this.props.history.push("/verifikasibuktipendaftaran");
                  });
              }
            })
            .catch((err) => {
              if (err) {
                if (err.code !== 403) {
                  let message;
                  if ('errors' in err) {
                    if (Array.isArray(err.errors)) {
                      message = err.errors[0];
                    } else {
                      message = err.errors;
                    }
                  } else {
                    message = "Koneksi ke server gagal.";
                  }
                  global.swal("Error", message, "info");
                }
              } else {
                global.swal.stopLoading();
                global.swal.close();
              }
            })
        )
      })
      .catch((err) => {
        if (err) {
          if (err.code !== 403) {
            let message;
            if ('errors' in err) {
              if (Array.isArray(err.errors)) {
                message = err.errors[0];
              } else {
                message = err.errors;
              }
            } else {
              message = "Koneksi ke server gagal.";
            }
            global.swal("Error", message, "info");
          }
        } else {
          global.swal.stopLoading();
          global.swal.close();
        }
      });
  };

  handleReturn = (event) => {
    event.preventDefault();
    global
      .swal({
        text: "Alasan dokumen dikembalikan",
        content: "input",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: ["Cancel", { text: "Submit", closeModal: false }],
      })
      .then((confirm) => {
        let errorMessage = { code: 403, message: "cancel" };
        if (!confirm) throw errorMessage;
        const data = [];
        let items;
        items = Object.create({});
        items.field = "note_return_bukti_transfer";
        items.value = confirm;
        data.push(items);
        const form_data = new FormData();
        form_data.append("registration_id", this.state.student_id);
        form_data.append("action", "back");
        form_data.append("data", JSON.stringify(data))
        trackPromise(
          fetch(global.variable.LINK_API + "flow/update", {
            method: "post",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + global.cookies.get("access_token"),
            },
            body: form_data,
          })
            // })
            .then(this.handleErrors)
            .then((response) => response.json())
            .then((resData) => {
              if (resData.message === "Success") {
                // console.log(resData);
                global
                  .swal("Success", "Berhasil Dikembalikan", "success")
                  .then((value) => {
                    this.props.history.push("/verifikasibuktipendaftaran");
                  });
              }
            })
            .catch((err) => {
              // console.log(err);
              if (err) {
                if (err.code !== 403) {
                  let message;
                  if ('errors' in err) {
                    if (Array.isArray(err.errors)) {
                      message = err.errors[0];
                    } else {
                      message = err.errors;
                    }
                  } else {
                    message = "Koneksi ke server gagal.";
                  }
                  global.swal("Error", message, "info");
                }
              } else {
                global.swal.stopLoading();
                global.swal.close();
              }
            })
        )
      })
      .catch(err => {
        if (err) {
          if (err.code !== 403) {
            let message;
            if ('errors' in err) {
              if (Array.isArray(err.errors)) {
                message = err.errors[0];
              } else {
                message = err.errors;
              }
            } else {
              message = "Koneksi ke server gagal.";
            }
            global.swal("Error", message, "info");
          }
        } else {
          global.swal.stopLoading();
          global.swal.close();
        }
      });

  };

  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="divContainter">
                  <MDBCard className="mb-5">
                    <MDBCardBody>
                      <MDBBreadcrumb color="cyan lighten-4">
                        <MDBBreadcrumbItem active>
                          <a href="/home">Home</a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          Verifikasi Bukti Bayar Pendaftaran
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>

                      {this.state.student_detail && this.state.student_detail.note_return_bukti_transfer ? (
                        <div className="alert alert-warning" role="alert">
                          <div className="font-weight-bold mb-1">Catatan Pengembalian Sebelumnya</div>
                          <div>{this.state.student_detail.note_return_bukti_transfer}</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <form onSubmit={this.handleSubmit}>
                        <div className="form-row">
                          <div className="form-group col-md-6 mb-2">
                            <label>Nama Siswa</label>
                            <input
                              className="form-control form-control-sm"
                              type="Text"
                              name="jalur"
                              value={localStorage.getItem("DATA_JALUR")}
                              disabled
                            />
                          </div>
                          {this.state.is_show ? this.form1() : ""}
                        </div>

                        {this.state.unit_detail ? (
                          <React.Fragment>
                            <hr />
                            <label
                              style={{
                                fontSize: 20,
                                textDecorationLine: "underline",
                              }}
                            >
                              Informasi Pembayaran
                            </label>
                            <div className="form-row">{this.formunit()}</div>
                          </React.Fragment>
                        ) : (
                          ""
                        )}

                        {this.state.is_show ? (
                          <div>
                            <hr />
                            <label
                              style={{
                                fontSize: 20,
                                textDecorationLine: "underline",
                              }}
                            >
                              Bukti Pembayaran
                            </label>
                          </div>
                        ) : (
                          ""
                        )}

                        {this.state.is_show ? this.formbukti() : ""}

                        <br></br>
                        <div className="row">
                          <div className="col-md-4 col-12">
                            <MDBBtn
                              onClick={this.handleTolak}
                              block
                              color="danger"
                              style={{
                                margin: 5,
                                height: 50,
                              }}
                            >
                              Tolak
                            </MDBBtn>
                          </div>
                          <div className="col-md-4 col-12">
                            <MDBBtn
                              color="danger"
                              onClick={this.handleReturn}
                              block
                              style={{
                                margin: 5,
                                height: 50,
                              }}
                            >
                              Kembalikan
                            </MDBBtn>
                          </div>
                          {/* {this.state.registration_type_id === "JU" &&
                            this.state.flow_id === 3 ? (
                          <div className="col-md-4">
                            <MDBBtn
                              color='yellow'
                              onClick={this.handleCadangan}
                              block
                              style={{
                                margin: 5,
                                height: 50,
                                backgroundColor: "#e6e600",
                              }}
                            >
                              Confirm Cadangan
                            </MDBBtn>
                            </div>
                          ) : (
                            ""
                          )} */}

                          {/* {this.state.registration_type_id === "JU" &&
                            (this.state.flow_id === 3 ||
                              this.state.flow_id === 11) ? (
                          <div className="col-md-3">
                            <MDBBtn
                              color='primary'
                              data-toggle="modal"
                              data-target="#modal"
                              block
                              style={{ margin: 5, height: 50 }}
                            >
                              Confirm
                            </MDBBtn>
                            </div>
                          ) : ( */}
                          <div className="col-md-4 col-12">
                            <MDBBtn
                              color="success"
                              data-toggle="modal"
                              data-target="#modal"
                              // onClick={this.handleWawancara}
                              block
                              disabled={this.state.isLoading}
                              type="submit"
                              style={{
                                margin: 5,
                                height: 50,
                                // backgroundColor: "#33cc33",
                                padding: "10px",
                              }}
                            >
                              {
                                this.state.isLoading ? (
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : 'Konfirmasi Bukti Bayar'
                              }
                            </MDBBtn>
                          </div>
                          {/* )} */}
                        </div>
                      </form>
                      {this.state.previewImage ? (
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.7)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => this.setState({ previewImage: "" })}
                        >
                          <img
                            src={this.state.previewImage}
                            alt="Bukti Bayar"
                            style={{
                              maxWidth: "90%",
                              maxHeight: "90%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Verifikasi_bukti_bayar_detail;
